import React, { useState } from 'react';
import Select from 'react-select';
// import { handleOnFocusById } from '../../common/utils/CommonUtils';
import './CustomSelect.css'
const pillDropdownVariants = new Set(["grid", "header"]);

export default function CustomSelect(props) {

    const [data, setData] = useState(null);
    const isPillDropdown = pillDropdownVariants.has(props.variant);

    const customStyles = {

        container: (base) => ({
            ...base,
            height: '100%',
            minWidth: props.variant === "grid" ? 0 : '7.39vw',
            width: '100%',
        }),

        control: (base, state) => ({
            ...base,
            border: props.variant === "grid"
                ? 0
                : (state.isFocused ? '0.052vw solid #6D1DF0' : 0),
            boxShadow: 'none',
            outline: 'none',
            height: '100%',
            minHeight: props.variant === "grid" ? "3.333vh" : (props.controlHeight || '2.08vw'),
            borderStyle: 'none',
            borderRadius: props.borderradiusValueContainer || (props.variant === "grid" ? "0.521vw" : props.variant === "header" ? "8px" : "0.42vw"),
            backgroundColor: props.backgroundColor || '#141414',
            '&:hover': {
                border: props.variant === "grid" ? 0 : '0.052vw solid #6D1DF0',
            }
        }),
        
        placeholder: (base) => ({
            ...base,
            fontSize: props?.placeholderFontSize || '0.83vw',
            fontWeight: props?.placeholderFontWeight || 400,
        }),
        menu: (base) => {
            if (isPillDropdown) {
                return {
                    ...base,
                    marginTop: "0.370vh",
                    marginBottom: 0,
                    backgroundColor: "#333333",
                    borderRadius: "0.313vw",
                    overflow: "hidden",
                    boxShadow: "0 0.370vh 0.625vw rgba(0, 0, 0, 0.35)",
                    zIndex: props.variant === "header" ? 1001 : 30,
                };
            }
            return {
                ...base,
                marginTop: "0.26vw",
                marginBottom: "0px",
                backgroundColor: "#333333",
                borderRadius: base.borderRadius,
                overflow: "hidden",
                boxShadow: base.boxShadow,
                zIndex: 30,
            };
        },
        menuList: (base) => {
            const hideScrollbar = {
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                "::-webkit-scrollbar": {
                    display: "none",
                },
            };
            if (isPillDropdown) {
                return {
                    ...base,
                    padding: "0.370vh 0.313vw",
                    backgroundColor: "#333333",
                    maxHeight: "min(14.583vw, 40vh)",
                    ...hideScrollbar,
                };
            }
            return {
                ...base,
                padding: 0,
                backgroundColor: "#333333",
            };
        },
        valueContainer: (base) => ({
            ...base,
            padding: props?.paddingValueContainer || "0.1vw 0.83vw",
        }),
        option: (base, state) => {
            if (isPillDropdown) {
                const backgroundColor = state.isSelected
                    ? "#6D1DF0"
                    : state.isFocused
                        ? "#444444"
                        : "transparent";

                return {
                    ...base,
                    padding: "1.204vh 0.625vw",
                    fontSize: props.optionFontSize || "0.729vw",
                    fontWeight: 600,
                    fontFamily: "Noto Sans, sans-serif",
                    lineHeight: 1.25,
                    minHeight: "2.963vh",
                    color: "#FFFFFF",
                    cursor: "pointer",
                    borderRadius: "0.208vw",
                    margin: "0.185vh 0",
                    backgroundColor,
                    ":active": {
                        backgroundColor: state.isSelected ? "#6D1DF0" : "#444444",
                    },
                };
            }
            return {
                ...base,
                padding: props.optionPadding || "0.88vw",
                fontSize: props.optionFontSize || "2 rem",
                fontWeight: base.fontWeight,
                fontFamily: base.fontFamily,
                color: "#FFFFFF",
                cursor: "pointer",
                backgroundColor: state.isSelected ? "#6D1DF0" : "transparent",
                "&:hover": {
                    backgroundColor: state.isSelected ? "#6D1DF0" : "#444444",
                },
                "&:active": {
                    backgroundColor: "#6D1DF0",
                },
            };
        },
        dropdownIndicator: (base) => ({
            ...base,
            color: "#999999",
            padding: isPillDropdown ? "0 0.521vw" : "0 0.5vw",
            "&:hover": {
                color: "#FFFFFF",
            },
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: props.singleValFontSize || "2 rem",
            fontWeight: props.variant === "header" || props.variant === "grid" ? 600 : base.fontWeight,
            fontFamily: props.variant === "header" || props.variant === "grid" ? "Noto Sans" : base.fontFamily,
            color: "#FFFFFF"
        }),
        input: (base) => ({
            ...base,
            fontWeight: '400',
            fontSize: '0.83vw',
            lineHeight: '0.83vw',
            color: '#FFFFFF;'
        })
    }

    const handleChange = (item) => {
        setData(item);

        props.handleChange(item);
    }

    return (
        <Select
            closeMenuOnSelect={props.closeMenuOnSelect}
            id={props.id}
            className={props.className || 'custom-select'}
            classNamePrefix={
                isPillDropdown
                    ? (props.className || "custom-select")
                    : undefined
            }
            value={props.hasOwnProperty('value') ? props.value : data}
            onChange={handleChange}
            isClearable={props.hasOwnProperty('isClearable') ? props.isClearable : true}
            options={props.options || []}
            getOptionValue={(option) => option[props['label']] || option['label'] || option.name}
            getOptionLabel={(option) => option[props['label']] || option['label'] || option.name}
            placeholder={props.placeholder}
            styles={customStyles}
            isMulti={props.isMulti || false}
            isDisabled={props.isDisabled ? true : false}
            // menuIsOpen={true}
            components={{
                //DropdownIndicator:() => null,
                IndicatorSeparator: () => null
            }}
            onFocus={() => {
                // handleOnFocusById(`${props.id || props.placeholder}`)
            }}
            isSearchable={props.isSearchable}
        />
    )
}


// behavior Optional
// Defines the transition animation. One of auto or smooth. Defaults to auto.

// block Optional
// Defines vertical alignment. One of start, center, end, or nearest. Defaults to start.

// inline Optional
// Defines horizontal alignment. One of start, center, end, or nearest. Defaults to nearest.